import styled from '@emotion/styled';
import {
  colorPalettes,
  Flex,
  SIZES,
  SPACES,
  Text
} from '@linearb/linui-common';
import { Button } from '@mui/material';

export const LearnMoreButton = styled(Button)`
  padding: 0.4rem 0.8rem;
  text-transform: capitalize;
  font-size: 1rem;
  border-radius: 0.4rem;
`;

export const StyledText = styled(Text)`
  font-size: ${SIZES['x-large']};
  color: ${({ theme }) => colorPalettes[theme.palette.mode].text.primary};
  margin-right: 1rem;
`;

const StyledLoginFooter = styled(Flex)`
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin-bottom: ${SPACES['medium']};
`;

export default StyledLoginFooter;
